import React from 'react';

const BlogSidebar = () => null;

export default BlogSidebar;
